import type { AboutProductSectionKey } from "@/composites/product";
import type { AboutProductBlock } from "@/domain/catalog";

const CMS_GROUP_TO_SECTION_KEY: Partial<
	Record<string, AboutProductSectionKey>
> = {
	dimensions: "dimensions",
	features: "features",
	care_safety: "careSafety",
	replacement_parts: "replacementParts"
};

export function resolveAboutProductSectionOrder(
	block: AboutProductBlock
): AboutProductSectionKey[] {
	return Object.keys(block)
		.map((key) => CMS_GROUP_TO_SECTION_KEY[key])
		.filter((key): key is AboutProductSectionKey => key !== undefined);
}
